'use client'

import { usePageData } from '@/contexts/PageDataContext'
import type { Maybe } from '@/frontend-types'
import { tagCMSBlock } from '@/helpers/layout'
import type { FC } from 'react'
import { Corridor } from '../atoms/Corridor'
import { Grid } from '../atoms/Grid'
import Breadcrumb from '../molecules/Breadcrumb'
import { PageHeadTertiaryAssets } from '../molecules/PageHeadTertiaryAssets'

export type PageHeadTertiaryType = {
	title?: Maybe<string>
}

const PageHeadTertiary: FC<PageHeadTertiaryType> = ({ title }) => {
	const pageData = usePageData()
	const titleOrPageTitle = title || pageData.title
	return (
		<section className={tagCMSBlock(['hero'])}>
			<PageHeadTertiaryAssets />
			<Corridor className="pt-4xl pb-6xl">
				<Grid>
					<div className="col-span-full flex flex-col gap-y-xl tablet-p:col-span-7 tablet-l:col-span-10">
						{titleOrPageTitle && <h1 className="text-h1-1 text-blue">{titleOrPageTitle}</h1>}
						<Breadcrumb />
					</div>
				</Grid>
			</Corridor>
		</section>
	)
}

export default PageHeadTertiary
